import { observer } from "mobx-react-lite";
import React from "react";
import { useNavigate } from "react-router";
import UserStore from "../../store/UserStore";
import { homePageRoute, QUICK_VIEWS } from "../../utils/constants";
import { getCookie } from "../../utils/cookie";
import { logEvents, trackEvent } from "../../utils/functions";
const QuickViewsSub = ({
  dispMsgUrl,
  dispMsg,
  dispImg,
  alt,
  navigateto,
  id,
  styleProps,
  instrumentType,
  instrumentCount,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    trackEvent(QUICK_VIEWS);
    logEvents(QUICK_VIEWS);
    const pageTitle = `${instrumentCount} Instruments in ${instrumentType}`;
    if (instrumentType !== "Infinity") {
      navigate(`/portfolio/quickDetails/${id?.id}/${instrumentType}`, {
        state: {
          from: homePageRoute,
          title: pageTitle,
        },
      });
    } else {
      let Id = null;
      const familyId = UserStore.userData.family_id || getCookie("famid");
      const userId = UserStore.userData.user_id || getCookie("userid");

      UserStore.getData === "fam" ? (Id = familyId) : (Id = userId);
      UserStore.setIsNavigated(true);

      navigate(`/portfolio/subassetclassdetailsQuick/${Id}/fromHome`, {
        state: { from: "homeScreen", title: pageTitle },
      });
    }
  };

  return (
    // <div
    //   className="quick_container_item"
    //   tabIndex={0}
    //   onClick={() => handleClick()}
    // >
    //   <div className="quick_container_title">
    //     <h6 className="titleh6">
    //       {dispMsg}
    //       <br />
    //       instruments
    //     </h6>
    //   </div>

    //   <img style={styleProps} src={dispImg} alt={alt} />
    // </div>
    <a
      href="/a11y-placeholder"
      className="quick_container_item"
      onClick={(e) => {
        e.preventDefault(); // stop browser navigation
        handleClick(); // compute route + navigate programmatically
      }}
    >
      <span className="quick_container_title">
        <span className="quick-view-message">{dispMsg}&nbsp;</span>
        <span className="quick-view-message line2-msg">instruments</span>
        {/* {dispMsg} <br /> instruments */}
      </span>

      <img style={styleProps} src={dispImg} alt={""} />
    </a>
  );
};

export default observer(QuickViewsSub);
